import {
  Box,
  FlexBox,
  List,
  ListItem,
  Text,
  TextInline,
} from '@trmediaab/zebra';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import StartNumberBadge from '~/components/StartNumberBadge';

const formatCategory = (category = '', numStarts) => {
  let formatted = category;

  if (['a', 'b', 'b/c', 'c', 'd'].includes(category.toLowerCase())) {
    formatted = `${category}-häst${numStarts > 1 ? 'ar' : ''}`;
  }

  return formatted.toUpperCase();
};

const RankedStarts = ({ starts, bet_type }) => (
  <FlexBox flexDirection="column" gap="3">
    {Object.keys(starts).map(category => (
      <Fragment key={category}>
        <Box px="2,5" py="2" backgroundColor="background.secondary">
          <Text
            color="brands.travrondenSpel"
            fontSize="10px"
            fontWeight="extraBold"
          >
            {formatCategory(category, starts[category].length)}
          </Text>
        </Box>

        <List gap="2">
          {starts[category]
            .filter(
              ({ start_number, horse }) =>
                start_number != null && horse != null,
            )
            .map(({ id, start_number, horse, ranking, scratched }) => (
              <ListItem display="flex" alignItems="center" key={id}>
                <FlexBox gap="2" alignItems="center" width="224px">
                  <StartNumberBadge
                    start_number={start_number}
                    bet_type={bet_type}
                    scratched={scratched}
                  />
                  <Text
                    fontSize="1"
                    fontWeight="semiBold"
                    textDecoration={scratched ? 'line-through' : undefined}
                  >
                    {horse.name}
                  </Text>
                </FlexBox>

                {ranking.valuation != null && (
                  <TextInline fontSize="1">{ranking.valuation}%</TextInline>
                )}
              </ListItem>
            ))}
        </List>
      </Fragment>
    ))}
  </FlexBox>
);

RankedStarts.propTypes = {
  starts: PropTypes.object.isRequired,
  bet_type: PropTypes.string.isRequired,
};

export default RankedStarts;
